<template>
  <modal
    name="perguntaEdit"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
  >
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab title="Editando Pergunta">
            <div class="xrow">
              <div class="col-1-1">
                <div class="form-group">
                  <label>Descrição</label>
                  <input class="form-control" v-model="item.descricao" />
                </div>
              </div>
            </div>

            <div class="xrow">
              <div class="col-1-3">
                <div class="form-group">
                  <label>Tipo</label>
                  <select
                    name="perguntaTipo"
                    id="perguntaTipo"
                    class="form-control"
                    v-model="item.tipo"
                    @change="onChange"
                  >
                    <option value="TEXT">Text</option>
                    <option value="RADIO">Radio</option>
                    <option value="CHECKBOX">Checkbox</option>
                    <option value="SELECT">Select</option>
                    <option value="MULTISELECT">Multiselect</option>
                    <option value="TEXTAREA">Textarea</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="xrow">
              <div class="col-1-1">
                <div class="form-group">
                  <Alternativas
                    :key="item.tipo"
                    :close="close"
                    :pergunta="item"
                  />
                </div>
              </div>
            </div>

            <div class="xrow edit-buttons">
              <button
                class="button button-success"
                @click="addAlternativas"
              >
                Salvar
              </button>
              &nbsp;
              <button
                class="button"
                @click="close"
              >
                Fechar
              </button>
            </div>
          </CTab>
        </CTabs>
      </div>
    </div>
  </modal>
</template>

<script>
import CloseModal from "../CloseModal.vue";
import Alternativas from "./Alternativas.vue";

export default {
  name: "PerguntaEditBase",
  props: {
    item: { type: Object, required: true },
    close: { type: Function, required: true },
    formulario: { type: Object, required: true },
  },
  components: { CloseModal, Alternativas },
  methods: {
    addAlternativas() {
      const erro = this.validarPergunta();

      if (erro) {
        return this.$swal({
          title: "Atenção!",
          text: erro,
          icon: "warning",
        });
      }

      this.$emit("salvar-pergunta", this.item);
      this.closeModal();
    },
    validarPergunta() {
      const { descricao, tipo, alternativas } = this.item;

      if (!descricao || descricao.trim() === "") {
        return "A descrição da pergunta é obrigatória.";
      }

      if (!tipo) {
        return "O tipo da pergunta é obrigatório.";
      }

      const tiposQueExigemAlternativas = [
        "CHECKBOX",
        "RADIO",
        "SELECT",
        "MULTISELECT",
      ];

      if (tiposQueExigemAlternativas.includes(tipo)) {
        if (!alternativas.length) {
          return "Adicione pelo menos uma alternativa.";
        }

        const alternativasInvalidas = alternativas.filter(
          (alt) => !alt.descricao || alt.descricao.trim() === ""
        );

        if (alternativasInvalidas.length > 0) {
          return "Todas as alternativas devem ter uma descrição preenchida.";
        }
      }

      return null;
    },
    onChange(event) {
      this.item.tipo = event.target.value;
      this.item.alternativas = [];
    },
    closeModal() {
      this.close();
    },
  },
};
</script>
